import { createFileRoute, notFound } from '@tanstack/react-router';

import { ProjectSharedChatDetailScreen } from '@/features/projects/project-shared-chat-detail';
import { ProjectSharedMeetingDetailScreen } from '@/features/projects/project-shared-meeting-detail';

const ITEM_TYPES = ['chat', 'meeting'] as const;
type ItemType = (typeof ITEM_TYPES)[number];

function isItemType(value: string): value is ItemType {
  return (ITEM_TYPES as readonly string[]).includes(value);
}

export const Route = createFileRoute(
  '/_authenticated/projects/$projectId_/shared/$itemType/$itemId'
)({
  component: ProjectSharedItemRoute,
});

function ProjectSharedItemRoute() {
  const { projectId, itemType, itemId } = Route.useParams();

  if (!isItemType(itemType)) throw notFound();

  if (itemType === 'meeting') {
    return (
      <ProjectSharedMeetingDetailScreen
        key={itemId}
        projectId={projectId}
        meetingId={itemId}
      />
    );
  }

  return (
    <ProjectSharedChatDetailScreen
      key={itemId}
      projectId={projectId}
      chatId={itemId}
    />
  );
}
